export const LOCAL = 'LOCAL';
export const CHARISMA = 'CHARISMA';
export const EUROTAX = 'EUROTAX';
export const GTMOTIVE = 'GTMOTIVE';
